import videojs from "video.js";

export function removeClassIfElementExists(element: Element | null, className: string) {
  if (element) {
    videojs.dom.removeClass(element, className);
  }
}
